namespace GeniuzPOS.SalePromoCamp {
    export interface PromoDayForm {
        PromoDay: Serenity.StringEditor;
        PromoDayName: Serenity.StringEditor;
    }

    export class PromoDayForm extends Serenity.PrefixedContext {
        static formKey = 'SalePromoCamp.PromoDay';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PromoDayForm.init)  {
                PromoDayForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PromoDayForm, [
                    'PromoDay', w0,
                    'PromoDayName', w0
                ]);
            }
        }
    }
}
